var path = 'infrastructure/directives/views/update-wrapper.html';
var html = "<div> <div ng-show=busy.busy style=height:20px> <spin active=busy.busy></spin> </div> <div ng-show=!busy.busy> <error-box error=busy.error></error-box> <div ng-show=!busy.error> <div ng-transclude></div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/update-wrapper.html
// module id = 7880821276028971
// module chunks = 1